const sharedStyles = {
  accent: "#e16365",
};

export const darkTheme = {
  mainBgColor: "#333",
  mainTextColor: "#f9f9f9",
  ...sharedStyles,
};

export const lightTheme = {
  mainBgColor: "#f9f9f9",
  mainTextColor: "#333",
  ...sharedStyles,
};
